import React from 'react';

import { MyAssignments } from './my-assignments.component';
import { useMyCalibrationAssignments } from '../../../lib/services/calibration-assignment.service';

export const MyAssignmentsGraphQL: React.FC = () => {
  const {
    assignments, total, loading, loadingMore, onLoadMore, fetchError, loadMoreError,
  } = useMyCalibrationAssignments();

  return (
    <MyAssignments
      assignments={assignments}
      total={total}
      loading={loading}
      loadingMore={loadingMore}
      onLoadMore={onLoadMore}
      fetchError={fetchError}
      loadMoreError={loadMoreError}
    />
  );
};
